// Lite mode: a lighter version of the site for visitors on very limited data.
// Deliberately rare. It turns on only for Opera Mini, the browser's data-saver
// signal (navigator.connection.saveData, which few browsers send since Chrome
// dropped its Lite mode), or the reduced-data preference. Add ?lite=1 to the URL
// to force it (?lite=0 to force it off) when testing.
// Effects: html.lite styles in App.css (no blur, animations or timeline; solid
// panels), no larger background image, and trip photos aren't loaded.

type NavigatorWithConnection = Navigator & {connection?: {saveData?: boolean}};
type WindowWithOperaMini = Window & {operamini?: unknown};

function detectLite(): boolean {
    const forced = new URLSearchParams(window.location.search).get("lite");
    if (forced === "1") return true;
    if (forced === "0") return false;
    const operaMini = /Opera Mini/i.test(navigator.userAgent)
        || Object.prototype.toString.call((window as WindowWithOperaMini).operamini) === "[object OperaMini]";
    const saveData = (navigator as NavigatorWithConnection).connection?.saveData === true;
    const reducedData = window.matchMedia?.("(prefers-reduced-data: reduce)").matches === true;
    return operaMini || saveData || reducedData;
}

export const lite = detectLite();

if (lite) document.documentElement.classList.add("lite");
